import React from 'react'

import Icons from './../../../utils/import.icons'

interface Props{
    isAmenidades: boolean
    isSidebarHidden: boolean
    proyecto: any,
    secondaryBtnSelected: any,
    handleShowAmenidad: any
}

interface State{}

interface Info {
    Icons?: any
}

class AmenidadesSidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    handleCreateButtonsStructure = () => {
        const ameniadesIcons: Info = {Icons}
        return(
            this.props.proyecto.map((amenidad: any, index: number) => 
                    amenidad.Nombre !== "General View" ? (
                        <React.Fragment key={(index+2)*2}>
                        <div 
                        className={this.props.secondaryBtnSelected === amenidad.Nombre ? "btn-sidebar-amenidades selected": this.props.isSidebarHidden ? "btn-sidebar-amenidades-collapsed":"btn-sidebar-amenidades"} 
                        key={index} 
                        onClick={() => {this.props.handleShowAmenidad(amenidad.Nombre, ameniadesIcons.Icons[amenidad.Nombre+"2"], amenidad)}}
                        >
                            <img src={ameniadesIcons.Icons[this.props.secondaryBtnSelected === amenidad.Nombre ? amenidad.Nombre+"2":amenidad.Nombre]} alt=''/>
                            <div>{amenidad.Nombre}</div>
                        </div>
                        <hr className='secondary-bar-hr' key={(index+1) * 2}/>
                        </React.Fragment>):null
            )
        )
    }

    render(): React.ReactNode {
        return(
            <div className={!this.props.isSidebarHidden && this.props.isAmenidades ? 'amenidades-sidebar':'amenidades-collapsed'}>
                {
                    this.handleCreateButtonsStructure()
                }
            </div>
        )
    }
}

export default AmenidadesSidebar